import { Component } from '@angular/core';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { TableColumn } from 'src/app/shared/components/table/table-column.interface';
import { TableSearchRequest } from 'src/app/shared/components/table/table.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UserDetailsComponent } from '../../user-details/user-details.component';

@Component({
  selector: 'app-external-users-list',
  templateUrl: './external-users-list.component.html',
  styleUrls: ['./external-users-list.component.scss']
})
export class ExternalUsersListComponent {

  userData: any[] = [];
  resultsLength: number = 0;
  isLoadingResults: boolean = false;
  lastRequest?: TableSearchRequest;
  faPlus = faPlus;

  roles: string[] = [
    'Financial Advisor',
    'Financial Advisor Manager',
    'Financial Advisor Admin',
    'Portal Admin',
    'Portal Para Legal',
    'Portal Manager'
  ];

  columns: TableColumn[] = [
    { key: 'firstName',    label: 'First Name',    sortable: true, filterable: true },
    { key: 'lastName',     label: 'Last Name',     sortable: true, filterable: true },
    { key: 'emailAddress', label: 'Email',         sortable: true, filterable: true },
    { key: 'companyGroup', label: 'Company Group', sortable: true, filterable: true, filterKey: 'companyGroup.name' },
    { key: 'roleName',         label: 'Role',            sortable: true, filterable: true  },
    { key: 'lastLogin',    label: 'Last Login',    sortable: true, filterable: true, filterType: 'daterange' },
    { key: 'lastActivity', label: 'Last Activity', sortable: true },
    { key: 'accountDisabled', label: 'Status',     sortable: true, filterable: true, filterType: 'select',
      filterOptions: [
        { label: 'Enabled',  value: '{{bool}}false' },
        { label: 'Disabled', value: '{{bool}}true' }
      ]
    },
  ];

  constructor(
    private userService: UserService,
    public modalService: ModalService) {
  }

  onSearch(request: TableSearchRequest) {
    this.lastRequest = request;
    this.isLoadingResults = true;
    this.userService.externalUsers(request).subscribe({
      next: data => {
        this.userData = data.items;
        this.resultsLength = data.recordCount;
        this.isLoadingResults = false;
      },
      error: () => this.isLoadingResults = false
    });
  }

  editUser(user: any) {
    const modalRef = this.modalService.openWithOptions(UserDetailsComponent, { size: 'lg' });
    modalRef.componentInstance.userId = user.id;
    modalRef.componentInstance.internalUser = false;
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }

  addUser() {
    const modalRef = this.modalService.openWithOptions(UserDetailsComponent, { size: 'lg' });
    modalRef.componentInstance.internalUser = false;
    modalRef.result.then(
      (result) => { if (result) this.onSearch(this.lastRequest!); },
      () => {}
    );
  }

  isOnline(lastActivity: string): boolean {
    if (!lastActivity) return false;
    return new Date(lastActivity) > new Date(Date.now() - 5 * 60 * 1000);
  }
}